<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import getAPIUrl from '@/helpers/getAPIUrl'

let ipcRenderer
if (typeof process !== 'undefined' && process.type === 'renderer') {
  const { ipcRenderer: electronIpcRenderer } = require('electron')
  ipcRenderer = electronIpcRenderer
}

export default {
  name: 'App',

  data: () => ({
    //
  }),
  async beforeCreate () {
    if (ipcRenderer) {
      ipcRenderer.send('readApiUrl')
      ipcRenderer.on('asynchronous-reply', (event, res) => {
        this.$store.commit('setApiUrl', res)
      })
    } else {
      const res = await getAPIUrl()
      this.$store.commit('setApiUrl', res)
    }
  }
}
</script>
